import { FC } from 'react';

import Icon from '@telialt/common-icon/src';
import { isEmpty } from '@telialt/utils/src/helpers';

import { Salon } from '../../model';
import { RetailsTestID } from '../../test-ids';
import { SalonItemContainer, SalonItemTitle } from './SalonList.styles';

type Props = {
    salon: Salon;
    onClick: () => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
};

export const SalonItem: FC<Props> = ({ salon, onClick, onMouseEnter, onMouseLeave }) => {
    return (
        <SalonItemContainer
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            data-test={RetailsTestID.SALON_LIST_ITEM}
        >
            <SalonItemTitle>{salon.shop}</SalonItemTitle>
            {!isEmpty(salon.salonAttributeList) && (
                <div>
                    {salon.salonAttributeList.map((attribute, index) => (
                        <Icon key={index} type={attribute.icon} style={{ fontSize: 24 }} ariaLabel={attribute.name} />
                    ))}
                </div>
            )}
        </SalonItemContainer>
    );
};
